var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtaskExpanded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.607239 0L7.39276 0C7.51287 3.33974e-05 7.63027 0.0464399 7.73013 0.133353C7.82999 0.220267 7.90781 0.343785 7.95377 0.488291C7.99973 0.632798 8.01176 0.791806 7.98834 0.945213C7.96491 1.09862 7.90709 1.23954 7.82217 1.35016L4.42941 5.76842C4.31551 5.9167 4.16105 6 4 6C3.83895 6 3.68449 5.9167 3.57059 5.76842L0.17783 1.35016C0.0929137 1.23954 0.0350883 1.09862 0.0116636 0.945213C-0.0117612 0.791806 0.000266709 0.632798 0.0462263 0.488291C0.0921859 0.343785 0.170014 0.220267 0.269871 0.133353C0.369729 0.0464399 0.487132 3.33974e-05 0.607239 0Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtaskExpanded);
export default __webpack_public_path__ + "static/media/subtaskExpanded.1077c8b21a5ae347bc625b82ccc306f3.svg";
export { ForwardRef as ReactComponent };